import {useState} from 'react';
import {useKeyboard} from '../hooks/useKeyboard';
import '../styles/SpinController.css';

type Props = {
  onSpinChange: (spinning: boolean) => void;
};

export default function SpinController({onSpinChange}: Props) {
  const [endless, setEndless] = useState(false);

  useKeyboard({
    Space: (e) => {
      if (e.type === 'keydown') onSpinChange(true);
      if (e.type === 'keyup' && !endless) onSpinChange(false);
    },
    Escape: (e) => {
      if (e.type === 'keydown') onSpinChange(false);
    },
  });

  return (
    <div className="spin-controller">
      <div className="spin-mode">
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={endless}
            onChange={(e) => setEndless(e.target.checked)}
          />
          <span className="slider"></span>
          <span className="toggle-label">Endless Mode</span>
        </label>
        <div className="mode-description">
          {endless 
            ? "Wheel will continue spinning until you press Escape" 
            : "Wheel will stop when Space is released"}
        </div>
      </div>

      <div className="spin-buttons">
        <button 
          className="spin-button"
          onMouseDown={() => onSpinChange(true)} 
          onMouseUp={() => !endless && onSpinChange(false)}
          onMouseLeave={() => !endless && onSpinChange(false)}
          onTouchStart={() => onSpinChange(true)}
          onTouchEnd={() => !endless && onSpinChange(false)}
        >
          Hold to Spin
        </button>
        
        <button
          className="stop-button"
          onClick={() => onSpinChange(false)}
        >
          Stop
        </button>
      </div>
    </div>
  );
}
